export const IMAGES = {
  PRODUCT_PLACEHOLDER: '/marketplace/assets/images/product_placeholder.webp',
  APP_DOWNLOAD_QR: '/marketplace/assets/images/QR-Homepage.webp',
  APP_STORE: '/marketplace/assets/images/app_store.webp',
  PLAY_STORE: '/marketplace/assets/images/google_play_store.webp',
  MOBILE_ERROR: '/marketplace/assets/images/mobile_error.webp',
  DESKTOP_ERROR: '/marketplace/assets/images/desktop_error.webp',
  LOADING_GIF: '/marketplace/assets/images/spinner-animation.gif',
  APP_DOWNLOAD_QR_V2: '/marketplace/assets/images/QR-handshakepage.png',
};

export const ICONS = {
  SHOPPING_BAG: '/marketplace/assets/icons/shopping_bag.svg',
  STORE: '/marketplace/assets/icons/store.svg',
  MENU: '/marketplace/assets/icons/menu.svg',
  PROFILE_ICON: '/marketplace/assets/icons/profile_icon.svg',
  MAP_MARKER: '/marketplace/assets/icons/map-marker.svg',
};
